import React from "react";
import Private from "./Private";
import Calendar from "../../pages/Calendar";
import Tickets from "../../pages/Tickets";
import Dashboard from "../../pages/Dashboard";
import Service from "../../pages/services";
import Terms from "../../pages/Terms";
import InspectorAssign from "../../pages/InspectorAssign";
import InspectorModule from "../../pages/InspectorModule";
import InspectorSchedule from "../../pages/InspectorModule/InspectorSchedule";
import Client from "../../pages/Client";
import ClientDetail from "../../pages/Client/detail";
import ClientCompliance from '../../pages/Client/detail/components/AnnualCompliance'
import ClientTickets from "../../pages/Client/detail/components/Tickets";
import BuildingDetail from "../../pages/Client/detail/components/Units";
import UnitTickets from "../../pages/Client/detail/components/UnitTickets";
import InspectorRole from "../../pages/InspectorRole";
import RouterErrorPage from "../../components/ErrorBoundary";
import ErrorFallback from "../../components/ErrorFallback";
import LeadCompliance from "../../pages/LeadCompliance";
import FireNotice from "../../pages/FireNotice";
import FireNoticeCompliance from "../../pages/Client/detail/components/FireNotice";
import ClientMessaging from "../../pages/ClientMessaging";
import Buildings from "../../pages/Buildings";
import ScheduleInspection from "../../pages/ScheduleInspection";
import { HPDViolations, HPDTickets, HPDAffidavits, PendingRequests } from "../../pages/HPD";
import ViolationDetail from "../../pages/HPD/components/HPDViolations/components/Detail";
import Inspections from "../../pages/Client/detail/components/Inspections";
import LL55 from "../../pages/LL55";
import ClientBuildings from "../../pages/Client/detail/components/ClientBuildings";
import Reports from "../../pages/Reports";
import ComingSoon from "../../components/ComingSoon";
import DocumentUpload from "../../pages/DocumentUpload";

  export const Pages = {
    element: <Private />,
    children: [
      {
        element: <Dashboard />,
        errorElement: <ErrorFallback />,
        children: [
          {
            path: "/home",
            element: <Calendar />,
          },
          {
            path: "/ticket",
            element: <Tickets />,
          },
          {
            path: "ticket/inspector-assign",
            element: <InspectorAssign />,
          },
          {
            path: "/schedule-inspection",
            element: <ScheduleInspection />,
          },
          {
            path: "/hpd/violations",
            element: <HPDViolations />,
          },
          {
            path: "/hpd/violations/:id",
            element: <ViolationDetail />,
          },
          {
            path: "/hpd/tickets",
            element: <HPDTickets />,
          },
          {
            path: "/hpd/affidavits",
            element: <HPDAffidavits />,
          },
          {
            path: "/hpd/pending-requests",
            element: <PendingRequests />,
          },
          {
            path: "/client",
            // element: <Client />,
            element: (
              <div className="loader-center">
                <p className="orange-color font-family-700">Coming Soon</p>
              </div>
            ),
          },
          {
            path: "/client/:clientId",
            element: <ClientDetail />,
          },
          {
            path: "/client/:clientId/buildings",
            element: <ClientBuildings />,
          },
          {
            path: "/client/:clientId/compliance",
            element: <ClientCompliance />,
          },
          {
            path: "/client/:clientId/fire-notice",
            element: <FireNoticeCompliance />,
          },
          {
            path: "/client/:clientId/building/:buildingId",
            element: <BuildingDetail />,
          },
          {
            path: "/client/:clientId/building/:buildingId/unit/:unitId",
            element: <UnitTickets />,
          },
          {
            path: "/client/:clientId/tickets",
            element: <ClientTickets />,
          },
          {
            path: "/inspector",
            element: <InspectorModule />,
            // element: (
            //   <div className="loader-center">
            //     <p className="orange-color font-family-700">Coming Soon</p>
            //   </div>
            // ),
          },
          {
            path: "/inspector/:inspectorId",
            element: <InspectorSchedule />,
          },
          {
            path: "/service",
            element: <Service />,
          },
          {
            path: "/terms",
            element: <Terms />,
            // element: (
            //   <div className="loader-center">
            //     <p className="orange-color font-family-700">Coming Soon</p>
            //   </div>
            // ),
          },
          {
            path: "/inspector-role",
            element: <InspectorRole />,
          },
          {
            path: "/lead-compliance",
            element: <LeadCompliance />,
          },
          {
            path: "/fire-notice",
            element: <FireNotice />,
          },
          {
            path: "/client-messaging",
            element: <ClientMessaging />,
          },
          {
            path: "/buildings",
            element: <Buildings />,
          },
          {
            path: "/client/:clientId/inspections",
            element: <Inspections />,
          },
          {
            path: "/ll55",
            element: <LL55 />,
          },
          {
            path: "/reports",
            element: <Reports />,
          },
          {
            path: "/document-upload",
            element: <DocumentUpload />,
          },
          // {
          //   path: "/parapet",
          //   element: <ComingSoon />,
          // },
          // {
          //   path: "/backflow-hpd-tickets",
          //   element: <ComingSoon />,
          // },
        ],
      },
    ],
  };
